import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";

import {
  pinToDashboardAction,
  setPagesAction,
  setSharedPageAction,
  setUserNameAction,
  UsersFetchAction, 
  setdashboardDriveData , 
} from "./actionCreator";

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setUserName: setUserNameAction,
    changeCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    // setPages(state, action) {
    //   state.pages = action.payload;
    // },
    setPaginationModel(state, action) {
      state.paginationModel = action.payload;
    },
    setGrid(state, action) {
      state.grid = action.payload;
    },
    setdashboardDriveData(state, action) {
      state.driveDashboard = action.payload;
    },
    setPages: setPagesAction,
    setSharedPage: setSharedPageAction,
    pinToDashboardList: pinToDashboardAction,
    dashBoardDrive : setdashboardDriveData , 
  },
  extraReducers: (builder) => {
    builder.addCase(UsersFetchAction.pending, (state) => {
      state.loading = true;
    });
    //eslint-disable-next-line
    builder.addCase(UsersFetchAction.fulfilled, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(UsersFetchAction.rejected, (state) => {
      state.loading = false;
      state.users = [];
    });
  },
});

export const {
  setUserName,
  changeCurrentPage,
  setPages,
  setSharedPage,
  setPaginationModel,
  setGrid,
  pinToDashboardList,
  dashBoardDrive , 
  // setdashboardDriveData,
} = dashboardSlice.actions;

// Re-export async thunk
export { UsersFetchAction };

export default dashboardSlice.reducer;
